import React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ApplicationState } from '../../../store';

//component state
interface IStateProps {

}

//component props
interface IOwnProps {

}

//redux state props
interface IReduxStateProps {

}

interface IReduxDispatchProps {

}

type Props = IOwnProps & IReduxStateProps & IReduxDispatchProps & WithTranslation;

class OrderProcessing extends React.PureComponent<Props, IStateProps> {

    render() {
        return <div className="order-detail">
            <h2>{ this.props.t( 'basket.wizard.orderProcessing.headline' ) }</h2>
            <p className="lead">
                { this.props.t( 'basket.wizard.orderProcessing.message' ) }
            </p>
        </div>
    }
}

const mapStateToProps = ( state: ApplicationState ): IReduxStateProps => ( {

} );

const mapDispatchToProps = ( dispatch: Function ): IReduxDispatchProps => ( {

} );

export default connect<IReduxStateProps, IReduxDispatchProps, IOwnProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps
)( withTranslation()( OrderProcessing ) );




